import store from '@/store'
import { EStoreModules } from '@/store/storeType'
import { EAuthActions, EAuthMutations } from '@rfc/rfc-components-library/store'
import {
    type TokenType,
    type UserDataModel,
    type UserModel,
    ELocalStorage
} from '@rfc/rfc-components-library/types'
import { getItemFromStorage } from '@rfc/rfc-components-library/utils'
import moment from 'moment'
import router from '../router'

const TokenService = {
    getLocalRefreshToken: () => {
        const user = JSON.parse(localStorage.getItem('user') ?? '')
        return user?.access_token
    },
    getLocalAccessToken: (): string | undefined =>
        getItemFromStorage<UserDataModel>('user')?.access_token,

    updateLocalAccessToken: (token: string) => {
        const user = getItemFromStorage<UserDataModel>('user')
        localStorage.setItem(
            'user',
            JSON.stringify({
                ...(user ?? {}),
                expires_at: moment(user?.expires_at)
                    .add(user?.expires_in ?? 3600, 'seconds')
                    .toDate(),
                access_token: token
            })
        )
    },
    getUser: () => {
        const user = getItemFromStorage<TokenType>('user')
        if (!user) store(router)?.dispatch(`${EStoreModules.AUTHENTICATION}/${EAuthActions.LOGOUT}`)
        return user
    },
    setUser: async (user: UserDataModel | null) => {
        if (!user)
            return store(router)?.dispatch(`${EStoreModules.AUTHENTICATION}/${EAuthActions.LOGOUT}`)
        const localUser = getItemFromStorage<UserDataModel>('user')
        localStorage.setItem(
            'user',
            JSON.stringify({
                ...localUser,
                ...user,
                expires_at: moment((user as UserDataModel)?.expires_at ?? localUser?.expires_at)
                    .add(
                        (user as UserDataModel)?.expires_in ?? localUser?.expires_in ?? 3600,
                        'seconds'
                    )
                    .toDate()
            })
        )

        store(router)?.commit(
            `${EStoreModules.AUTHENTICATION}/${EAuthMutations.SET_USER}`,
            (user as UserDataModel).access_token
        )
    },
    setMe: async (user: UserModel) => {
        localStorage.setItem('me', JSON.stringify(user))
        store(router)?.commit(`${EStoreModules.USER}/${EAuthActions.ME}`, user)
    },
    removeUser: () => {
        if (TokenService.isImpersonateUser()) {
            TokenService.swapImpersonateUser()
            TokenService.removeImpersonateUser()
        }
        localStorage.removeItem('user')
    },

    setImpersonateUser: async (user: TokenType | null) => {
        if (!user) return
        localStorage.setItem('impersonate', JSON.stringify(user))
    },
    removeImpersonateUser: () => localStorage.removeItem('impersonate'),

    getImpersonateUser: () => getItemFromStorage<UserDataModel>('impersonate'),

    isImpersonateUser: () => Boolean(localStorage.getItem('impersonate')),

    swapImpersonateUser: (user = null) => {
        localStorage.removeItem(ELocalStorage.FILTERS)
        localStorage.removeItem(ELocalStorage.RECENTLY)
        window.dispatchEvent(
            new CustomEvent('recentlyVisited', {
                bubbles: true,
                detail: null
            })
        )
        if (!user) {
            TokenService.setUser(TokenService.getImpersonateUser())
            TokenService.removeImpersonateUser()
        } else {
            TokenService.setImpersonateUser(TokenService.getUser())
            TokenService.setUser(user)
        }
        /* router.push(HOME_URL) */
    }
}

// TODO : Check export
export default TokenService
